export enum ENUM_CARD_EVENT_METRIC {
  IMPRESSION = 'IMPRESSION',
  REACH = 'REACH',
  CLICK = 'CLICK',
  UNIQUE_CLICK = 'UNIQUE_CLICK',
}
